const extractMediaData = require("./extractMediaData");
const extractLinkData = require("./extractLinkData");

module.exports = function transformCallToActionData(entity, sitemap) {
	const { id, type, attributes, relationships } = entity;

	const bg_image =
		relationships && relationships.field_background_image
			? extractMediaData(entity, "field_background_image")
			: null;

	const logo_image =
		relationships && relationships.field_logo
			? extractMediaData(entity, "field_logo")
			: null;

	const link =
		attributes && attributes.field_to
			? extractLinkData(attributes.field_to, sitemap)
			: null;
	let txt =
		attributes && attributes.body
			? attributes.body.transformed
				? attributes.body.transformed
				: attributes.body.value
			: null;
	let data = {
		id,
		type,
		title: entity.attributes.title,
		subtitle:
			attributes && attributes.field_subtitle
				? attributes.field_subtitle
				: null,
		body: txt,
		backgroundColor:
			attributes && attributes.field_background_color
				? attributes.field_background_color
				: null,
		backgroundImage: bg_image ? bg_image.src : null,
		logo: logo_image ? logo_image.src : null,
		headingType:
			attributes && attributes.field_cta_heading_type
				? attributes.field_cta_heading_type
				: "h3",
		to: link ? link.to : null,
		toLabel: link ? link.label : null,
		search: attributes && attributes.field_display_search_form === true,
		newsletter: attributes && attributes.field_display_newsletter_form === true,
		searchPlaceholder:
			attributes && attributes.field_search_placeholder
				? attributes.field_search_placeholder
				: "Search this website...",
		newsletterPlaceholder:
			attributes && attributes.field_newsletter_placeholder
				? attributes.field_newsletter_placeholder
				: "Enter your email...",
		layout:
			attributes && attributes.field_cta_layout
				? attributes.field_cta_layout
				: null,
		searchVariant:
			attributes && attributes.field_cta_search_vari
				? attributes.field_cta_search_vari
				: "filled",
	};
	return data;
};
